const Page = ({ extentClassName, pageHeaderContent, sidebarFilterContent, searchResultContent }) => {
    return (
        <div className={`page ${extentClassName ? extentClassName : ''}`}>
            <div className="page-header">
                {pageHeaderContent}
            </div>
            <div className="page-container">
                <div className="page-sidebar">
                    {sidebarFilterContent}
                </div>
                <div className="page-results">
                    {searchResultContent}
                </div>
            </div>
        </div>
    );
};

export default Page;
